import React, { useRef, useState, useLayoutEffect } from "react";
import ReactDOM from "react-dom";

const GAP = 4;

const BadgeTooltip = ({ trigger, children, rowCount }) => {
  const triggerRef = useRef(null);
  const tooltipRef = useRef(null);
  const [coords, setCoords] = useState(null);
  const [hovered, setHovered] = useState(false);

  function updatePosition() {
    const triggerEl = triggerRef.current;
    const tooltipEl = tooltipRef.current;
    if (!triggerEl || !tooltipEl) return;

    const triggerRect = triggerEl.getBoundingClientRect();
    const tooltipRect = tooltipEl.getBoundingClientRect();

    const spaceBelow = window.innerHeight - triggerRect.bottom;
    const spaceRight = window.innerWidth - triggerRect.left;

    const showAbove = spaceBelow < tooltipRect.height + GAP;
    const showLeft = spaceRight < tooltipRect.width;

    setCoords({
      top: showAbove ? triggerRect.top - tooltipRect.height - GAP : triggerRect.bottom + GAP,
      left: showLeft ? triggerRect.right - tooltipRect.width : triggerRect.left,
    });
  }

  useLayoutEffect(() => {
    if (hovered) updatePosition();
  }, [hovered]);

  return (
    <div
      ref={triggerRef}
      className="code_badge__tooltip__wrapper"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {trigger}
      {ReactDOM.createPortal(
        <div
          ref={tooltipRef}
          className="code_badge__tooltip__container"
          style={{
            position: "fixed",
            top: coords ? coords.top : -9999,
            left: coords ? coords.left : -9999,
            visibility: hovered && coords ? "visible" : "hidden",
            opacity: hovered && coords ? 1 : 0,
            "--row-count": rowCount,
          }}
        >
          {children}
        </div>,
        document.body
      )}
    </div>
  );
};

export default BadgeTooltip;
